import { Routes } from '@angular/router';
import {Login} from './auth/login/login';
import {AdminGuard} from './guard/admin.guard';
import {ProductRegistrationCard} from './pages/product-registration-card/product-registration-card';

export const routes: Routes = [
  { path:'', redirectTo:'main',pathMatch:'full'},
  { path:'login',
    component: Login
  },
  {
    path: 'admin',
    loadComponent:()=> import('./admin/dashboard/dashboard').then(m=>m.Dashboard),
    loadChildren:()=> import('./admin/admin.route'),
    canActivate: [AdminGuard]
  },
  {
    path: '',
    loadComponent:()=> import('./home/layout/layout').then(m=>m.Layout),
    loadChildren:()=> import('./pages/pages.route'),
  },
  {
    path: 'product-registration/:owner',
    component:ProductRegistrationCard
  },
];
